<template>
  <v-card flat width="1000px" class="mb-16">
    <v-card-text style="height: 740px" class="pa-0">
      <v-row no-gutters justify="center" class="mt-6">
        <v-col cols="6">
          <v-row no-gutters justify="center">
            <v-col cols="12" class="ml-4 mb-4">
              <b>Preview do player</b>
            </v-col>
            <v-col cols="12">
              <v-card width="392" height="219" class="bgImg pt-2" flat>
                <v-card
                  class="ml-2"
                  :color="group.boxColor"
                  :style="{ opacity: group.boxOpacity }"
                  width="200"
                  height="80"
                >
                  <span
                    class="ml-2"
                    :style="{
                      color: group.fontColor,
                      fontSize: group.fontSize + 'px',
                      fontFamily: group.fontFamily + ' !important',
                    }"
                  >
                    {{ boxLines.text1 }} <br />
                  </span>
                  <span
                    class="ml-2"
                    :style="{
                      color: group.fontColor,
                      fontSize: group.fontSize + 'px',
                      fontFamily: group.fontFamily + ' !important',
                    }"
                  >
                    {{ boxLines.text2 }} <br />
                  </span>
                  <span
                    class="ml-2"
                    :style="{
                      color: group.fontColor,
                      fontSize: group.fontSize + 'px',
                      fontFamily: group.fontFamily + ' !important',
                    }"
                  >
                    {{ boxLines.text3 }} <br />
                  </span>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12">
              <span class="caption"
                >Imagem utilizada apenas para pré-visualizar o player</span
              >
            </v-col>
            <v-col cols="12" class="mt-6">
              <v-row no-gutters>
                <v-col cols="12">
                  <span><b>Segurança do vídeo</b></span>
                </v-col>
                <v-col cols="12" class="mt-2 mb-4">
                  <span class="body-2">
                    A segurança do vídeo implica na quantidade de vezes, em
                    porcentagem, que o componente como mostrado acima, será
                    apresentado durante o vídeo. <br /><br />
                    Lembre-se que quanto maior a porcentagem selecionada maior o
                    custo proporcionalmente, já que implica em x, y e z.
                    <br /><br />
                    Exemplo: 10% de tráfego vao te custar X em um caso de Y
                    alunos por vídeo de tamanho Z.
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="mt-4">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row no-gutters>
                    <span><b>Ativar segurança dos vídeos desse grupo</b></span>
                    <v-switch
                      v-model="group.active"
                      class="ml-4 mt-0 pt-0"
                      dense
                      hide-details
                    ></v-switch>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mt-2 mb-4">
                  <span class="body-2">
                    A partir do momento que você muda esse status para true
                    <br />
                    Os videos que estão dentro do grupo, vão parar de funcionar
                    com a url do embed padrão<br />
                    Só vai funcionar o video, caso tenha a url assinada com o
                    secret ou com o private token
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-col cols="12" class="ml-4 pt-0 mt-0">
            <b>Configurações do player</b>
          </v-col>
          <v-card flat>
            <v-card-text class="pa-0 pl-6">
              <v-container class="pl-0 pt-0">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <v-text-field
                          v-model="group.name"
                          :label="'Nome do grupo'"
                          outlined
                          dense
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-select-legacy
                          v-model="group.fontFamily"
                          :items="fontFamilyItems"
                          item-text="text"
                          item-value="value"
                          :label="'Fonte principal'"
                          outlined
                          dense
                          color="primary"
                        ></v-select-legacy>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="5">
                            <v-subheader class="pl-0 pb-4">
                              Tamanho da fonte
                            </v-subheader>
                          </v-col>
                          <v-slider
                            v-model="group.fontSize"
                            hide-details
                            thumb-label
                            :min="6"
                            :max="18"
                          ></v-slider>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="5">
                            <v-subheader class="pl-0 pb-4">
                              Opacidade do fundo
                            </v-subheader>
                          </v-col>
                          <v-slider
                            v-model="group.boxOpacity"
                            hide-details
                            thumb-label
                            :min="0"
                            :max="1"
                            :step="0.01"
                          ></v-slider>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row no-gutters align="center">
                          <v-col cols="5">
                            <span>Cor da fonte</span>
                          </v-col>
                          <v-col cols="7">
                            <v-menu
                              offset-x
                              v-model="menuFontColor"
                              top
                              nudge-bottom="105"
                              nudge-left="16"
                              :close-on-content-click="false"
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  class="ml-2"
                                  :color="group.fontColor"
                                  v-on="on"
                                  :style="setMenuFontColor"
                                  icon
                                  elevation="3"
                                ></v-btn>
                              </template>
                              <v-color-picker
                                elevation="3"
                                v-model="group.fontColor"
                                flat
                                mode="hexa"
                                hide-mode-switch
                                :maxlength="7"
                              ></v-color-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <v-row no-gutters align="center">
                          <v-col cols="5">
                            <span>Cor da caixa</span>
                          </v-col>
                          <v-col cols="7">
                            <v-menu
                              offset-x
                              v-model="menuBoxColor"
                              top
                              nudge-bottom="105"
                              nudge-left="16"
                              :close-on-content-click="false"
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  class="ml-2"
                                  :color="group.boxColor"
                                  v-on="on"
                                  :style="setMenuBoxColor"
                                  icon
                                  elevation="3"
                                ></v-btn>
                              </template>
                              <v-color-picker
                                elevation="3"
                                v-model="group.boxColor"
                                flat
                                mode="hexa"
                                hide-mode-switch
                                :maxlength="7"
                              ></v-color-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <v-row no-gutters>
                          <v-col cols="8">
                            <v-subheader class="px-0">
                              Porcentagem do componente em tela:
                            </v-subheader>
                          </v-col>
                          <v-col cols="4">
                            <v-select-legacy
                              v-model="group.percentTs"
                              :items="drmPercents"
                              outlined
                              style="width: 100px"
                              dense
                              hide-details
                            >
                              <template v-slot:selection="{ item }">
                                <span> {{ item * 100 }}% </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span> {{ item * 100 }}% </span>
                              </template>
                            </v-select-legacy>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card-actions class="pa-0 mt-8">
            <v-btn
              class="pl-0"
              color="error"
              elevation="0"
              text
              @click="handleDeleteGroup(selectedGroup)"
            >
              <v-icon> mdi-delete-outline </v-icon>
              <span>Remover grupo</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="primary white--text"
              min-width="185px"
              @click="handleConfirm"
              :loading="isFetching"
              :disabled="isFetching"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import drmApi from '@/services/drmApi'

export default {
  name: 'DrmEditGroup',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    groupId: '',
    group: {
      name: '',
      percentTs: 0.1,
      active: false,
      fontFamily: 'fredoka-regular',
      fontColor: '#FFFFFFFF',
      fontSize: 12,
      boxColor: '#7999CEFF',
      boxOpacity: 1,
    },
    boxLines: {
      text1: 'Licenciado para',
      text2: 'Panda Video',
      text3: 'CPF 123.456.789-00',
    },
    fontFamilyItems: [
      { text: 'Fredoka Regular', value: 'fredoka-regular' },
      { text: 'Arial', value: 'arial' },
      { text: 'Helvetica', value: 'helvetica' },
      { text: 'Times New Roman', value: 'times-new-roman' },
    ],
    folderId: '',
    drmPercents: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
    menuFontColor: false,
    menuBoxColor: false,
  }),
  props: {
    selectedGroup: Object,
  },
  computed: {
    setMenuFontColor() {
      return {
        backgroundColor: this.group.fontColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    setMenuBoxColor() {
      return {
        backgroundColor: this.group.boxColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
  },
  watch: {
    selectedGroup: {
      immediate: true,
      handler(val) {
        this.groupId = val.id
        this.group.name = val.name
        this.group.percentTs = val.percent_ts
        this.group.active = val.active
        this.group.fontFamily = val.config['font-family'] || 'fredoka-regular'
        this.group.fontColor = val.config['font-color']
        this.group.fontSize = val.config['font-size']
        this.group.boxColor = val.config['box-color']
        this.group.boxOpacity = val.config['box-opacity']
      },
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    handleConfirm() {
      let groupObject = {
        name: this.group.name,
        percent_ts: this.group.percentTs,
        active: this.group.active,
        'font-family': this.group.fontFamily.toString(),
        'font-color': this.group.fontColor.toString(),
        'font-size': this.group.fontSize.toString(),
        'box-color': this.group.boxColor.toString(),
        'box-opacity': this.group.boxOpacity.toString(),
      }
      this.handleEdit(groupObject)
    },
    async handleEdit(groupObject) {
      this.isFetching = true
      try {
        let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
        this.$root.$emit('updateDrmGroup', ret.data)
        this.handleClose()
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
        console.log('ret update', ret)
      } catch (e) {
        console.log('e', e)
      }
      this.isFetching = false
    },
    handleClose() {
      this.open = false
    },
    async handleDeleteGroup() {
      // try {
      //   let ret = await drmApi.deleteDrmGroup(group.id)
      //   this.drmWatermarkGroups = this.drmWatermarkGroups.filter(
      //     (item) => item.id != group.id
      //   )
      //   this.selectedItems = []
      //   console.log('drm delete', ret)
      // } catch (e) {
      //   this.loadings.deactivateDrm = false
      //   console.log('e', e)
      // }
      this.$root.$emit('drmRemoveGroupModal', this.selectedGroup)
    },
  },
}
</script>

<style lang="scss">
.bgImg {
  background-image: url('../../assets/pandaVideoScreenShot.jpg');
  background-size: contain;
}
</style>
